/* tslint:disable */
/* eslint-disable */
/* @relayHash 1f1f36e605cf0ee0f306c6fb1e8c2719 */

import { ConcreteRequest } from "relay-runtime";
export type RefreshTokenHandlerAuthControlQueryVariables = {};
export type RefreshTokenHandlerAuthControlQueryResponse = {
    readonly settings: {
        readonly auth: {
            readonly integrations: {
                readonly local: {
                    readonly enabled: boolean;
                    readonly allowRegistration: boolean;
                    readonly targetFilter: {
                        readonly stream: boolean;
                    };
                };
                readonly oidc: {
                    readonly enabled: boolean;
                    readonly allowRegistration: boolean;
                    readonly targetFilter: {
                        readonly stream: boolean;
                    };
                };
                readonly google: {
                    readonly enabled: boolean;
                    readonly allowRegistration: boolean;
                    readonly targetFilter: {
                        readonly stream: boolean;
                    };
                };
                readonly facebook: {
                    readonly enabled: boolean;
                    readonly allowRegistration: boolean;
                    readonly targetFilter: {
                        readonly stream: boolean;
                    };
                };
            };
        };
    };
};
export type RefreshTokenHandlerAuthControlQuery = {
    readonly response: RefreshTokenHandlerAuthControlQueryResponse;
    readonly variables: RefreshTokenHandlerAuthControlQueryVariables;
};



/*
query RefreshTokenHandlerAuthControlQuery {
  settings {
    auth {
      integrations {
        local {
          enabled
          allowRegistration
          targetFilter {
            stream
          }
        }
        oidc {
          enabled
          allowRegistration
          targetFilter {
            stream
          }
        }
        google {
          enabled
          allowRegistration
          targetFilter {
            stream
          }
        }
        facebook {
          enabled
          allowRegistration
          targetFilter {
            stream
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enabled",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        ({
            "alias": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "kind": "LinkedField",
            "name": "targetFilter",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stream",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ], v1 = ({
        "alias": null,
        "args": null,
        "concreteType": "Auth",
        "kind": "LinkedField",
        "name": "auth",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AuthIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocalAuthIntegration",
                        "kind": "LinkedField",
                        "name": "local",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OIDCAuthIntegration",
                        "kind": "LinkedField",
                        "name": "oidc",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoogleAuthIntegration",
                        "kind": "LinkedField",
                        "name": "google",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacebookAuthIntegration",
                        "kind": "LinkedField",
                        "name": "facebook",
                        "plural": false,
                        "selections": (v0 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "RefreshTokenHandlerAuthControlQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "RefreshTokenHandlerAuthControlQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "1f1f36e605cf0ee0f306c6fb1e8c2719",
            "metadata": {},
            "name": "RefreshTokenHandlerAuthControlQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '81a2920a9729895599dfdec13f7934d2';
export default node;
